var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":_vm.transitionName},on:{"enter":_vm.handleEnter,"leave":_vm.handleLeave}},[_c('div',{class:_vm.classes},[_c('p',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm._f("plusMessageAnalyze")(_vm.content,_vm.defaultMessage)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }